<template>
  <div class="feedback">
    <transition name="fade" @enter="enterFeedback">
      <feedback-error
        v-if="showableFeedback"
        :message="'ログインできませんでした'"
      />
    </transition>
  </div>
</template>
<script>
import FeedbackError from '../../atoms/feedbacks/feedback-error'

export default {
  components: {
    FeedbackError
  },
  props: {
    isFailedLogin: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data() {
    return {
      showableFeedback: false
    }
  },
  mounted() {
    this.showableFeedback = this.isFailedLogin
  },
  methods: {
    enterFeedback() {
      setTimeout(() => {
        this.showableFeedback = false
      }, 3000)
    }
  }
}
</script>
